const buildKey = (key: string) => {
  return ['ccn-flows', key].join(':')
}

export const REMOVABLE_VALUE = 'undefined'

export const setLsItem = <T>(inKey: string, valueToStore?: T): void => {
  const key = buildKey(inKey)
  // Save to local storage
  if (valueToStore !== REMOVABLE_VALUE && valueToStore !== undefined) {
    window.localStorage.setItem(
      key,
      typeof valueToStore === 'object' ? JSON.stringify(valueToStore) : String(valueToStore),
    )
  } else {
    window.localStorage.removeItem(key)
  }
}

export const getLsItem = <T>(inKey: string) => {
  const key = buildKey(inKey)
  const item = window.localStorage.getItem(key)

  try {
    return item ? (JSON.parse(item) as T) : undefined
  } catch {
    return item ? (item as unknown as T) : undefined
  }
}
